export const environment = {
  production: false,
  apiBaseUrl: 'https://dev-api.larissabotelhoadvocacia.com/api/v1',
  // Mapeado de GOOGLE_LOGIN_ENABLED / GOOGLE_LOGIN_CLIENT_ID — configurar por ambiente.
  // Client ID abaixo está registrado no Google Console apenas para localhost:4200 (testes locais).
  googleLoginEnabled: true,
  googleLoginClientId: '493025668770-fmljarjhh9dnjc7npqkspgn2pep8jpv2.apps.googleusercontent.com',
};

